import React, { useState } from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { triggerBanner } from "web/redux/ducks/follow-designer-banner";
import { hideMainNavigation, showMainNavigation } from "web/redux/ducks/main-navigation";
import analytics from "web/script/analytics/analytics";
import styles from "./main-navigation-toggle-mobile.module.css";

const MENU_OPENED = "opened";
const MENU_CLOSED = "closed";

function extractNavigation(state) {
    return state.mainNavigationReducer;
}

function selectIsBannerVisible(state) {
    return state.followDesignerBannerReducer.show;
}

export function MainNavigationToggleMobile() {
    const [shouldShowBanner, setShouldShowBanner] = useState(false);
    const { selectedGender, visible } = useReduxSelector(extractNavigation);
    const bannerVisible = useReduxSelector(selectIsBannerVisible);
    const dispatch = useDispatch();

    function sendAnalytics(menuVisibility) {
        const gender = selectedGender || "women";
        analytics.event("nav", menuVisibility, `nav_${gender.toLowerCase()}_menu`);
    }

    function toggleVisibility() {
        if (visible) {
            if (shouldShowBanner && !bannerVisible) {
                dispatch(triggerBanner(true));
            }
            dispatch(hideMainNavigation());
            document.body.classList.remove("no-scroll");
            sendAnalytics(MENU_CLOSED);
        } else {
            if (bannerVisible) {
                setShouldShowBanner(true);
                dispatch(triggerBanner(false));
            }
            dispatch(showMainNavigation());
            document.body.classList.add("no-scroll");
            sendAnalytics(MENU_OPENED);
        }
    }

    return (
        <button
            className={visible ? styles.burgerCross : styles.burgerContainer}
            onClick={toggleVisibility}
        >
            <div className={styles.burgerBar1} />
            <div className={styles.burgerBar2} />
            <div className={styles.burgerBar3} />
        </button>
    );
}

export default withReduxProvider(MainNavigationToggleMobile);
